import React, { useState, useRef } from 'react'
import './trips.css'
import { RxCross2 } from "react-icons/rx";
import axios from 'axios';
import { SERVER_URL } from '../../ServerUrl';
import Swal from "sweetalert2";
import { useSelector } from "react-redux";


const UploadOperatorImages = ({ updateOperatorsImages }) => {
    const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
    const [uploadedImageFile, setUploadedImageFile] = useState(null);
    const operatorId = useSelector((state) => state?.auth?.operator?._id);
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setUploadedImageUrl(imageUrl);
            setUploadedImageFile(file);
        }
    };
    const handleUploadButtonClick = () => {
        fileInputRef.current.click();
    };

    const ResetState = () => {
        setUploadedImageUrl(null)
    }

    console.log(uploadedImageFile, "uploadedImageconsole", uploadedImageUrl)

    const SavePhoto = async () => {
        const auth = sessionStorage.getItem("token");
        console.log(auth, "auth123", operatorId)
        try {
            const formData = new FormData();

            if (uploadedImageFile) {
                formData.append('images', uploadedImageFile);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No image uploaded.',
                    confirmButtonText: 'OK',
                });
                return;
            }

            // Send the FormData object to the server
            const res = await axios.patch(
                `${SERVER_URL}/operator/${operatorId}/upload-image`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        auth: `${auth}`,
                    },
                }
            );

            // Handle the response
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Photo uploaded successfully',
                confirmButtonText: 'OK',
            });
            console.log(res, "resoperator")
            updateOperatorsImages(res?.data?.operator?.images);
            setUploadedImageUrl(null);
            setUploadedImageFile(null);
        } catch (err) {
            console.error('Error saving photo:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while saving your photo. Please try again.',
                confirmButtonText: 'OK',
            });
        }
    };




    return (
        <>
            <div className='uploadImageSectio'>
                {!uploadedImageUrl && (<div className="upload-section">
                    <input
                        type="file"
                        // accept="image/*"
                        onChange={handleFileChange}
                        ref={fileInputRef}
                        style={{ display: "none" }} // Hide default input
                    />
                    <button className="SAVEButton-Profile h-8 px-3  updateBtn1" onClick={handleUploadButtonClick}>Upload Image</button>
                </div>
                )}

                {/* Display Uploaded Image */}
                {uploadedImageUrl && (
                    <>
                        <div style={{ width: "100%" }}>
                            <div className="uploaded-image-container" style={{ display: "flex", gap: "3px" }}>
                                <img src={uploadedImageUrl} alt="Uploaded" className="uploaded-image-Profile" />
                                <RxCross2 style={{ color: "red", fontSize: "20px" }} onClick={ResetState} />
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <button onClick={SavePhoto} className='SAVEButton-Profile h-8 px-3  updateBtn1'>Upload Photo</button>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    )
}

export default UploadOperatorImages
